exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px){.date-pick .date-picker-input{max-width:50%!important}}", ""]);

// exports
